import { materialColorNeeds } from './materialColors.js';

export function buildSimulationNeedsMatrix(model = {}) {
  const columns = new Map();
  const rows = (model.items || []).map((item, index) => {
    const cells = new Map();
    for (const line of item.supplierMaterials || item.materials || []) {
      const cutting = (item.cutting || []).find((p) => p.materials.some((m) => m.id === line.source_line_id));
      const process = cutting?.name || line.process_name || 'Sin proceso';
      const processId = cutting?.process_id || line.process_id || process;
      const supplier = line.supplier_name || 'Sin proveedor';
      const key = JSON.stringify([processId, line.supplier_id || supplier]);
      const order = item.supplierProcessOrder?.[line.process_source_line_id] ?? Infinity;
      if (!columns.has(key)) columns.set(key, { key, processId, process, supplier, order });
      else columns.get(key).order = Math.min(columns.get(key).order, order);
      if (!cells.has(key)) cells.set(key, []);
      cells.get(key).push({ ...line, process, reference: line.supplier_ref || line.material_code || '', colors: materialColorNeeds(line, item.colorLines) });
    }
    return { key: `${item.product_id || item.code}:${index}`, code: item.code, description: item.description, garments: item.totalQuantity, image: item.image || null, cells };
  });
  return { rows, columns: [...columns.values()].sort((a, b) => (a.order - b.order) || a.process.localeCompare(b.process, 'es') || a.supplier.localeCompare(b.supplier, 'es')) };
}

// Both views consume the exact same material/colour needs and article details.
export function buildSimulationReportGroups(matrix) {
  const result = new Map();
  for (const row of matrix?.rows || []) for (const lines of row.cells.values()) for (const line of lines) for (const color of line.colors) {
    const supplierKey = line.supplier_id || line.supplier_name || 'Sin proveedor';
    const key = JSON.stringify([supplierKey, line.reference || line.source_line_id, line.unit, color.color]);
    if (!result.has(key)) result.set(key, { key, supplierKey, name: line.name, supplier: line.supplier_name || 'Sin proveedor', reference: line.reference, unit: line.unit, color: color.color, total: 0, amount: 0, articles: [] });
    const group = result.get(key);
    group.total += color.totalQuantity;
    group.amount += color.totalQuantity * Number(line.unit_cost || 0);
    group.articles.push({ ...line, article: row.code, description: row.description, image: row.image, garments: row.garments, needed: color.totalQuantity });
  }
  return [...result.values()].sort((a, b) => a.supplier.localeCompare(b.supplier, 'es'));
}
